<script setup>
import Navbar from "./components/Navbar.vue";
import Hero from "./components/Hero.vue";
import About from "./components/About.vue";
import MissionVision from "./components/MissionVision.vue";
import Projects from "./components/Projects.vue";
import ContactUs from "./components/ContactUs.vue";
import Footer from "./components/Footer.vue";
import Team from "./components/Team.vue";
import Portfolio from "./components/Portfolio.vue";
import Investment from "./components/Investment.vue";
import Testimonials from "./components/Testimonials.vue";
</script>

<template>
    <div class="font-sans text-gray-900 bg-black overflow-x-hidden w-full max-w-full">
        <Navbar />
        <Hero />
        <About />
        <MissionVision />
        <Projects />
        <Portfolio />
        <Testimonials />
        <Investment />
        <Team />
        <ContactUs />
        <Footer />
    </div>
</template>
